import { gql } from '@apollo/client';
import { EdmundsGraphQLFederation } from 'client/data/graphql/graphql-client';
import { GRAPHQL_FRAGMENTS } from 'client/data/constants/graphql-fragments';
import { createModelSegment } from 'client/data/luckdragon/segment';
import { withMetrics } from 'client/data/api/api-metrics';

export function getBestCategoryCarsPath() {
  return 'bestCategoryCars';
}

export const CarReviewsModel = createModelSegment('carReviews', [
  /**
   * @see getBestCategoryCarsPath
   */
  {
    path: 'bestCategoryCars',
    resolve(match, context) {
      return withMetrics(EdmundsGraphQLFederation, context)
        .query(gql`
          ${GRAPHQL_FRAGMENTS.editorialSegmentFields}
          query {
            midsize3RowSUVs: editorialVehicleRankings(
              edmundsTypeCategory: "SUV"
              market: "SUVs"
              subsegment: "Midsize 3-row"
            ) {
              ...editorialSegmentFields
            }
            midsizeSedans: editorialVehicleRankings(
              edmundsTypeCategory: "Sedan"
              market: "Sedans"
              subsegment: "Midsize"
            ) {
              ...editorialSegmentFields
            }
            largeTrucks: editorialVehicleRankings(edmundsTypeCategory: "Truck", market: "", subsegment: "Large") {
              ...editorialSegmentFields
            }
            midsizeElectricSUVs: editorialVehicleRankings(
              edmundsTypeCategory: "Electric"
              market: "Electric"
              subsegment: "Midsize electric SUVs"
            ) {
              ...editorialSegmentFields
            }
            midsizePluginHybridSUVsVehicles: editorialVehicleRankings(
              edmundsTypeCategory: "Hybrid"
              market: "Hybrids"
              subsegment: "Midsize plug-in hybrid SUVs"
            ) {
              ...editorialSegmentFields
            }
            luxurySportCoupes: editorialVehicleRankings(
              edmundsTypeCategory: "Coupe"
              market: "Luxury coupes"
              subsegment: "Sport"
            ) {
              ...editorialSegmentFields
            }
            smallHatchbacks: editorialVehicleRankings(
              edmundsTypeCategory: "Hatchback"
              market: ""
              subsegment: "Small"
            ) {
              ...editorialSegmentFields
            }
            smallSUVs: editorialVehicleRankings(edmundsTypeCategory: "SUV", market: "SUVs", subsegment: "Small") {
              ...editorialSegmentFields
            }
          }
        `)
        .then(categories => Object.values(categories).map(category => category[0]));
    },
  },
]);
